"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MathOff_exports = {};
__export(MathOff_exports, {
  default: () => MathOff_default
});
module.exports = __toCommonJS(MathOff_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.875 0.25C20.0443 0.25 20.1875 0.315104 20.3047 0.445312C20.4349 0.5625 20.5 0.705729 20.5 0.875V19.625C20.5 19.7943 20.4349 19.9375 20.3047 20.0547C20.1875 20.1849 20.0443 20.25 19.875 20.25H1.125C0.955729 20.25 0.80599 20.1849 0.675781 20.0547C0.558594 19.9375 0.5 19.7943 0.5 19.625V0.875C0.5 0.705729 0.558594 0.5625 0.675781 0.445312C0.80599 0.315104 0.955729 0.25 1.125 0.25H19.875ZM18.625 1.5H2.375C2.21875 1.5 2.08203 1.55208 1.96484 1.65625C1.86068 1.7474 1.79557 1.86458 1.76953 2.00781L1.75 2.125V18.375C1.75 18.5312 1.79557 18.668 1.88672 18.7852C1.99089 18.8893 2.11458 18.9544 2.25781 18.9805L2.375 19H18.625C18.7812 19 18.9115 18.9544 19.0156 18.8633C19.1328 18.7591 19.2044 18.6354 19.2305 18.4922L19.25 18.375V2.125C19.25 1.95573 19.1849 1.8125 19.0547 1.69531C18.9375 1.5651 18.7943 1.5 18.625 1.5ZM14.7773 4L14.9141 4.01953C14.9792 4.01953 15.0378 4.03906 15.0898 4.07812C15.1549 4.10417 15.2135 4.13672 15.2656 4.17578C15.3307 4.24089 15.3828 4.3125 15.4219 4.39062C15.4609 4.45573 15.487 4.52734 15.5 4.60547V7.10547V7.22266C15.487 7.28776 15.4609 7.35286 15.4219 7.41797C15.3958 7.48307 15.3503 7.54167 15.2852 7.59375C15.2201 7.65885 15.1419 7.71094 15.0508 7.75C14.9727 7.77604 14.8815 7.78906 14.7773 7.78906C14.6862 7.78906 14.5951 7.77604 14.5039 7.75C14.4258 7.71094 14.3542 7.66536 14.2891 7.61328C14.2109 7.5612 14.1523 7.49609 14.1133 7.41797C14.0742 7.33984 14.0547 7.26172 14.0547 7.18359V5.38672H7.43359L10.9492 9.70312L11.0273 9.83984C11.0404 9.87891 11.0534 9.91797 11.0664 9.95703C11.0794 9.99609 11.0859 10.0417 11.0859 10.0938C11.099 10.1589 11.099 10.224 11.0859 10.2891C11.0729 10.3542 11.0404 10.4128 10.9883 10.4648L10.9492 10.543L7.41406 15.1133H14.0547V13.3945V13.2969C14.0677 13.2318 14.0872 13.1667 14.1133 13.1016C14.1393 13.0365 14.1784 12.9844 14.2305 12.9453C14.2956 12.8672 14.3607 12.8151 14.4258 12.7891C14.5039 12.75 14.5885 12.724 14.6797 12.7109H14.7773L14.9141 12.7305C14.9792 12.7435 15.0378 12.763 15.0898 12.7891C15.1549 12.8151 15.2135 12.8477 15.2656 12.8867C15.3307 12.9388 15.3828 13.0039 15.4219 13.082C15.4609 13.1602 15.487 13.2383 15.5 13.3164V15.8164L15.4805 15.9336C15.4674 15.9987 15.4479 16.0573 15.4219 16.1094C15.3958 16.1615 15.3568 16.2135 15.3047 16.2656C15.2526 16.3307 15.1875 16.3828 15.1094 16.4219C15.0312 16.4609 14.9531 16.487 14.875 16.5H6.4375C6.39844 16.487 6.35938 16.4805 6.32031 16.4805C6.28125 16.4674 6.2487 16.4609 6.22266 16.4609C6.15755 16.4349 6.09896 16.4089 6.04688 16.3828C6.00781 16.3568 5.96875 16.3307 5.92969 16.3047C5.82552 16.2266 5.73438 16.1419 5.65625 16.0508C5.59115 15.9466 5.54557 15.8359 5.51953 15.7188C5.49349 15.6016 5.48698 15.4844 5.5 15.3672C5.52604 15.25 5.57812 15.1393 5.65625 15.0352L5.69531 14.957L9.44531 10.1523L5.71484 5.5625L5.65625 5.46484L5.59766 5.34766C5.57161 5.30859 5.55208 5.26953 5.53906 5.23047C5.53906 5.17839 5.53906 5.1263 5.53906 5.07422L5.51953 4.97656V4.82031C5.53255 4.72917 5.55859 4.64453 5.59766 4.56641C5.64974 4.47526 5.70833 4.39062 5.77344 4.3125C5.86458 4.22135 5.96224 4.14974 6.06641 4.09766C6.18359 4.04557 6.3138 4.01302 6.45703 4H14.7773Z",
      fill: "currentColor"
    }
  )
);
const SvgMathOff = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MathOff_default = SvgMathOff;
